import { useEntitySearch } from '@/common/presentation/hooks/useEntitySearch';

export const useEquipmentSearch = () => {
  return useEntitySearch();
};
